import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesInternalBank } from "../../constants";
import { InternalBankHistoryItem } from "../../financial.types";

export const requestInternalBankHistory = async (
  params: GetListRequestParams
): Promise<GetListResponse<InternalBankHistoryItem>> => {
  return await instance.get(ApiRoutesInternalBank.InternalBankHistory, {
    params
  });
};
